import { matiereMatch } from './matiere';

/**
 * Filtre un tableau de `resultats` selon le rôle / contexte, logique jusque-là
 * dupliquée dans DataLoader, DetailClasse et DetailEleve.
 *  - chef            → ne garder que la matière `matiereFilter` (si `matiereFilter`
 *                      absent → inchangé) ;
 *  - prof + groupe   → ne garder que `r.groupNom === groupNom` ;
 *  - sinon           → inchangé.
 */
export const filterResultatsRole = (resultats, { role, matiereFilter, groupNom, resultatsFilter }) => {
  if (!Array.isArray(resultats)) return resultats;
  if (role === 'chef') {
    if (!matiereFilter) return resultats;
    return resultats.filter((r) => matiereMatch(r.matiere, matiereFilter));
  }
  if (role === 'professeur' && groupNom && resultatsFilter === 'groupe') {
    return resultats.filter((r) => r.groupNom === groupNom);
  }
  return resultats;
};

/**
 * Applique `filterResultatsRole` à tous les élèves d'un `classeDetail`.
 * Flags pour absorber les divergences historiques :
 *  - `filterStudentsByMatiere` (chef) : retire aussi de la liste les élèves d'une
 *    autre matière (comportement DataLoader) ;
 *  - `removeEmpty` : retire les élèves sans résultat après filtrage (DetailClasse).
 */
export const applyRoleResultatsFilter = (
  classeDetail,
  { role, matiereFilter, groupNom, resultatsFilter, removeEmpty = false, filterStudentsByMatiere = false },
) => {
  if (!classeDetail?.eleves) return { eleves: [] };
  // Chef sans matière sélectionnée → pas de filtrage (comportement DataLoader).
  if (role === 'chef' && !matiereFilter) return classeDetail;

  const isChef = role === 'chef';
  const isGroupe = role === 'professeur' && groupNom && resultatsFilter === 'groupe';
  if (!isChef && !isGroupe) return classeDetail;

  let eleves = classeDetail.eleves;
  if (isChef && filterStudentsByMatiere) {
    eleves = eleves.filter((e) => !e.matiere || matiereMatch(e.matiere, matiereFilter));
  }
  eleves = eleves.map((e) => ({
    ...e,
    resultats: filterResultatsRole(e.resultats, { role, matiereFilter, groupNom, resultatsFilter }),
  }));
  if (removeEmpty) eleves = eleves.filter((e) => e.resultats.length > 0);
  return { ...classeDetail, eleves };
};
